import { render, staticRenderFns } from "./AxChip.vue?vue&type=template&id=48d9e8b4&scoped=true&"
import script from "./AxChip.vue?vue&type=script&lang=ts&"
export * from "./AxChip.vue?vue&type=script&lang=ts&"
import style0 from "./AxChip.vue?vue&type=style&index=0&id=48d9e8b4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48d9e8b4",
  null
  
)

export default component.exports